import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'boolean' })
export class BooleanPipe implements PipeTransform {

  transform(value: boolean, ...args: ['bloqueio']): string {
    if(args.includes('bloqueio')) {
      return value ? 'BLOQUEADO' : 'ATIVO'
    } else {
      return value ? 'Sim' : 'Não'
    }
  }
  
}